import * as types from '../types/analyticsTypes';
import * as analyticsServices from '../../services/analyticsServices';

export function fetchOverview(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_OVERVIEW_REQUEST });
    try {
      const data = await analyticsServices.fetchAnalyticsOverview(params);
      dispatch({ type: types.FETCH_OVERVIEW_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_OVERVIEW_FAILURE, payload: error.message });
    }
  };
}

export function fetchSalesChart(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_SALES_CHART_REQUEST });
    try {
      const data = await analyticsServices.fetchSalesChart(params);
      dispatch({ type: types.FETCH_SALES_CHART_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_SALES_CHART_FAILURE, payload: error.message });
    }
  };
}

export function fetchOrdersChart(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ORDERS_CHART_REQUEST });
    try {
      const data = await analyticsServices.fetchOrdersChart(params);
      dispatch({ type: types.FETCH_ORDERS_CHART_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_ORDERS_CHART_FAILURE, payload: error.message });
    }
  };
}

export function fetchRevenueByStore(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_REVENUE_BY_STORE_REQUEST });
    try {
      const data = await analyticsServices.fetchRevenueByStore(params);
      dispatch({ type: types.FETCH_REVENUE_BY_STORE_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({ type: types.FETCH_REVENUE_BY_STORE_FAILURE, payload: error.message });
      return [];
    }
  };
}
